import React, { useState } from 'react'
import '../../../assets/css/CustomStyle.css'


import {
    Accordion,
    AccordionHeader,
    AccordionBody,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
    Typography,
    Card,
} from "@material-tailwind/react";
import GrayBtn from '../../Button/GrayBtn';
import OrangeBtn from '../../Button/OrangeBtn';

export default function ChooseYourPlan() {
    const [open, setOpen] = React.useState(1);
    const [activeValue, setActiveValue] = useState('Billed Yearly')
    const Right = () => (
        <svg className='1350:w-[24px] 1350:h-[24px] 768:w-[22px] 768:h-[22px] w-[20px] h-[20px]' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5687 7.98109C17.7327 8.14518 17.8249 8.3677 17.8249 8.59971C17.8249 8.83173 17.7327 9.05425 17.5687 9.21834L11.0103 15.7768C10.9236 15.8634 10.8207 15.9322 10.7074 15.9791C10.5942 16.0261 10.4728 16.0502 10.3502 16.0502C10.2276 16.0502 10.1063 16.0261 9.993 15.9791C9.87975 15.9322 9.77685 15.8634 9.69018 15.7768L6.43168 12.5188C6.34811 12.4381 6.28145 12.3416 6.23559 12.2348C6.18973 12.1281 6.16559 12.0132 6.16458 11.8971C6.16357 11.7809 6.18571 11.6657 6.22971 11.5581C6.2737 11.4506 6.33868 11.3529 6.42083 11.2707C6.50299 11.1886 6.60068 11.1236 6.70822 11.0796C6.81575 11.0356 6.93097 11.0135 7.04715 11.0145C7.16334 11.0155 7.27815 11.0396 7.38491 11.0855C7.49166 11.1314 7.58821 11.198 7.66893 11.2816L10.3499 13.9626L16.3308 7.98109C16.4121 7.89978 16.5086 7.83528 16.6148 7.79127C16.721 7.74726 16.8348 7.72461 16.9498 7.72461C17.0647 7.72461 17.1785 7.74726 17.2847 7.79127C17.3909 7.83528 17.4874 7.89978 17.5687 7.98109Z" fill="#FF904C" />
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FF904C" />
        </svg>
    );
    const Close = () => (
        <svg className='1350:w-[24px] 1350:h-[24px] 768:w-[22px] 768:h-[22px] w-[20px] h-[20px]' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12.8166L9.14163 15.675C9.03469 15.7819 8.89858 15.8354 8.7333 15.8354C8.56802 15.8354 8.43191 15.7819 8.32497 15.675C8.21802 15.568 8.16455 15.4319 8.16455 15.2666C8.16455 15.1014 8.21802 14.9652 8.32497 14.8583L11.1833 12L8.32497 9.14163C8.21802 9.03469 8.16455 8.89858 8.16455 8.7333C8.16455 8.56802 8.21802 8.43191 8.32497 8.32497C8.43191 8.21802 8.56802 8.16455 8.7333 8.16455C8.89858 8.16455 9.03469 8.21802 9.14163 8.32497L12 11.1833L14.8583 8.32497C14.9652 8.21802 15.1014 8.16455 15.2666 8.16455C15.4319 8.16455 15.568 8.21802 15.675 8.32497C15.7819 8.43191 15.8354 8.56802 15.8354 8.7333C15.8354 8.89858 15.7819 9.03469 15.675 9.14163L12.8166 12L15.675 14.8583C15.7819 14.9652 15.8354 15.1014 15.8354 15.2666C15.8354 15.4319 15.7819 15.568 15.675 15.675C15.568 15.7819 15.4319 15.8354 15.2666 15.8354C15.1014 15.8354 14.9652 15.7819 14.8583 15.675L12 12.8166Z" fill="#FACBAE" />
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FACBAE" />
        </svg>
    );

    const handleOpen = (value) => setOpen(open === value ? 0 : value);
    console.log(handleOpen)

    const data = [
        {
            label: "Billed Monthly",
            value: "Billed Monthly",
            desc: <div className='600:flex grid grid-cols-1 items-end 999:justify-center justify-between 999:gap-[1.875rem] gap-[1.4rem]'>
                    <div className='999:py-[2.5rem] 768:py-[2.1rem] py-[25px]  999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                        <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text'>Starter</p>
                        <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$14.99/mo</h3>
                        <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>30 Credits per month</p>

                        <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                            <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 12.8166L9.14163 15.675C9.03469 15.7819 8.89858 15.8354 8.7333 15.8354C8.56802 15.8354 8.43191 15.7819 8.32497 15.675C8.21802 15.568 8.16455 15.4319 8.16455 15.2666C8.16455 15.1014 8.21802 14.9652 8.32497 14.8583L11.1833 12L8.32497 9.14163C8.21802 9.03469 8.16455 8.89858 8.16455 8.7333C8.16455 8.56802 8.21802 8.43191 8.32497 8.32497C8.43191 8.21802 8.56802 8.16455 8.7333 8.16455C8.89858 8.16455 9.03469 8.21802 9.14163 8.32497L12 11.1833L14.8583 8.32497C14.9652 8.21802 15.1014 8.16455 15.2666 8.16455C15.4319 8.16455 15.568 8.21802 15.675 8.32497C15.7819 8.43191 15.8354 8.56802 15.8354 8.7333C15.8354 8.89858 15.7819 9.03469 15.675 9.14163L12.8166 12L15.675 14.8583C15.7819 14.9652 15.8354 15.1014 15.8354 15.2666C15.8354 15.4319 15.7819 15.568 15.675 15.675C15.568 15.7819 15.4319 15.8354 15.2666 15.8354C15.1014 15.8354 14.9652 15.7819 14.8583 15.675L12 12.8166Z" fill="#FACBAE" />
                                                <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FACBAE" />
                                            </svg>
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] font-[450] text-[#999CA4] 999:text-center text-justify'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 12.8166L9.14163 15.675C9.03469 15.7819 8.89858 15.8354 8.7333 15.8354C8.56802 15.8354 8.43191 15.7819 8.32497 15.675C8.21802 15.568 8.16455 15.4319 8.16455 15.2666C8.16455 15.1014 8.21802 14.9652 8.32497 14.8583L11.1833 12L8.32497 9.14163C8.21802 9.03469 8.16455 8.89858 8.16455 8.7333C8.16455 8.56802 8.21802 8.43191 8.32497 8.32497C8.43191 8.21802 8.56802 8.16455 8.7333 8.16455C8.89858 8.16455 9.03469 8.21802 9.14163 8.32497L12 11.1833L14.8583 8.32497C14.9652 8.21802 15.1014 8.16455 15.2666 8.16455C15.4319 8.16455 15.568 8.21802 15.675 8.32497C15.7819 8.43191 15.8354 8.56802 15.8354 8.7333C15.8354 8.89858 15.7819 9.03469 15.675 9.14163L12.8166 12L15.675 14.8583C15.7819 14.9652 15.8354 15.1014 15.8354 15.2666C15.8354 15.4319 15.7819 15.568 15.675 15.675C15.568 15.7819 15.4319 15.8354 15.2666 15.8354C15.1014 15.8354 14.9652 15.7819 14.8583 15.675L12 12.8166Z" fill="#FACBAE" />
                                                <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FACBAE" />
                                            </svg>

                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] font-[450] text-[#999CA4] 999:text-center text-justify'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <GrayBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                            </div>
                        </div>
                    </div>
                    {/* Most Populer */}
                    <div className='pb-[2.5rem] orange-border 999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                        <p className='primray-bg 999:rounded-t-[1.875rem]  768:rounded-t-[1.5rem]  rounded-t-[1.2rem] py-[1rem] text-[1rem] font-[450] uppercase text-white'>Most Populer</p>
                        <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text 999:pt-[2.5rem] 768:pt-[2.1rem] pt-[25px]'>Premium</p>
                        <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$34.99/mo</h3>
                        <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>100 Credits per month</p>

                        <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                            <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <OrangeBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                            </div>
                        </div>
                    </div>
                    <div className='999:py-[2.5rem] 768:py-[2.1rem] py-[25px]  999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                        <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text'>Team</p>
                        <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$99.99/mo</h3>
                        <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>30 Credits per month</p>

                        <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                            <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li></li>
                                <li></li>

                            </ul>
                            <div>
                                <GrayBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                            </div>
                        </div>
                    </div>
            </div>,
        },
        {
            label: "Billed Yearly",
            value: "Billed Yearly",
            desc: <div className='600:flex grid grid-cols-1 items-end 999:justify-center justify-between 999:gap-[1.875rem] gap-[1.4rem]'>
                    <div className='999:py-[2.5rem] 768:py-[2.1rem] py-[25px]  999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                        <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text'>Starter</p>
                        <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$179.99/yr</h3>
                        <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>360 Credits per year</p>

                        <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                            <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 12.8166L9.14163 15.675C9.03469 15.7819 8.89858 15.8354 8.7333 15.8354C8.56802 15.8354 8.43191 15.7819 8.32497 15.675C8.21802 15.568 8.16455 15.4319 8.16455 15.2666C8.16455 15.1014 8.21802 14.9652 8.32497 14.8583L11.1833 12L8.32497 9.14163C8.21802 9.03469 8.16455 8.89858 8.16455 8.7333C8.16455 8.56802 8.21802 8.43191 8.32497 8.32497C8.43191 8.21802 8.56802 8.16455 8.7333 8.16455C8.89858 8.16455 9.03469 8.21802 9.14163 8.32497L12 11.1833L14.8583 8.32497C14.9652 8.21802 15.1014 8.16455 15.2666 8.16455C15.4319 8.16455 15.568 8.21802 15.675 8.32497C15.7819 8.43191 15.8354 8.56802 15.8354 8.7333C15.8354 8.89858 15.7819 9.03469 15.675 9.14163L12.8166 12L15.675 14.8583C15.7819 14.9652 15.8354 15.1014 15.8354 15.2666C15.8354 15.4319 15.7819 15.568 15.675 15.675C15.568 15.7819 15.4319 15.8354 15.2666 15.8354C15.1014 15.8354 14.9652 15.7819 14.8583 15.675L12 12.8166Z" fill="#FACBAE" />
                                                <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FACBAE" />
                                            </svg>
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] font-[450] text-[#999CA4] 999:text-center text-justify'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 12.8166L9.14163 15.675C9.03469 15.7819 8.89858 15.8354 8.7333 15.8354C8.56802 15.8354 8.43191 15.7819 8.32497 15.675C8.21802 15.568 8.16455 15.4319 8.16455 15.2666C8.16455 15.1014 8.21802 14.9652 8.32497 14.8583L11.1833 12L8.32497 9.14163C8.21802 9.03469 8.16455 8.89858 8.16455 8.7333C8.16455 8.56802 8.21802 8.43191 8.32497 8.32497C8.43191 8.21802 8.56802 8.16455 8.7333 8.16455C8.89858 8.16455 9.03469 8.21802 9.14163 8.32497L12 11.1833L14.8583 8.32497C14.9652 8.21802 15.1014 8.16455 15.2666 8.16455C15.4319 8.16455 15.568 8.21802 15.675 8.32497C15.7819 8.43191 15.8354 8.56802 15.8354 8.7333C15.8354 8.89858 15.7819 9.03469 15.675 9.14163L12.8166 12L15.675 14.8583C15.7819 14.9652 15.8354 15.1014 15.8354 15.2666C15.8354 15.4319 15.7819 15.568 15.675 15.675C15.568 15.7819 15.4319 15.8354 15.2666 15.8354C15.1014 15.8354 14.9652 15.7819 14.8583 15.675L12 12.8166Z" fill="#FACBAE" />
                                                <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FACBAE" />
                                            </svg>

                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] font-[450] text-[#999CA4] 999:text-center text-justify'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <GrayBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                            </div>
                        </div>
                    </div>
                    {/* Most Populer */}
                    <div className='pb-[2.5rem] orange-border 999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                        <p className='primray-bg 999:rounded-t-[1.875rem]  768:rounded-t-[1.5rem]  rounded-t-[1.2rem] py-[1rem] text-[1rem] font-[450] uppercase text-white'>Most Populer</p>
                        <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text 999:pt-[2.5rem] 768:pt-[2.1rem] pt-[25px]'>Premium</p>
                        <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$419.99/yr</h3>
                        <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>1200 Credits per year</p>

                        <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                            <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                                <li>
                                    <div className='flex items-center justify-center gap-[.625rem]'>
                                        <div>
                                            {Right()}
                                        </div>
                                        <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <OrangeBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                            </div>
                        </div>
                    </div>
                    <div className='999:py-[2.5rem] 768:py-[2.1rem] py-[25px]  999:rounded-[1.875rem]  768:rounded-[1.5rem]  rounded-[1.2rem] choose-card border border-[#E6E6E6] 1350:w-[25rem] 600:w-[21rem] w-full'>
                    <p className='768:text-[1.25rem] text-[1.8rem] font-medium primary-text'>Team</p>
                    <h3 className='999:text-[1.9375rem] 768:text-[1.7rem] 600:text-[1.5rem] text-[1.8rem] font-medium text-orange 999:py-[.5625rem] 768:py-[0.5rem] py-[0.3rem] 768:leading-[normal] leading-6 '>$1,199.99/yr</h3>
                    <p className='600:text-[.875rem] text-[1.1rem] font-[450]  '>360 Credits per year</p>

                    <div className='pt-[1.25rem] mt-[1.25rem] border-t border-[#E6E6E6] mx-[1.25rem]'>
                        <ul className='space-y-[1.25rem] pb-[1.25rem] 768:h-[17.75rem] 600:h-[19rem] h-auto overflow-auto'>
                            <li>
                                <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                    <div>
                                        {Right()}
                                    </div>
                                    <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li>
                                <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                    <div>
                                        {Right()}
                                    </div>
                                    <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li>
                                <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                    <div>
                                        {Right()}
                                    </div>
                                    <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li>
                                <div className='flex 999:items-center items-start justify-center 999:gap-[.625rem] gap-[0.45rem]'>
                                    <div>
                                        {Right()}
                                    </div>
                                    <p className='999:text-[1rem] 600:text-[0.8rem] text-[1.1rem] 999:text-center text-justify  font-[450]'>Lorem ipsum dolor sit amet consectetur.</p>
                                </div>
                            </li>
                            <li></li>
                            <li></li>

                        </ul>
                        <div>
                            <GrayBtn className='!1350:py-[1rem] 768:py-[.875rem] py-[0.6rem] !1350:px-[2rem] 768:px-[1.5rem] px-[1.2rem] !text-[1.125rem] mx-auto' value='Get Started' />
                        </div>
                    </div>
                </div>

            </div>,
        },
    ];

    const TABLE_HEAD = ["Data", "Starter", "Premium", "Team"];

    const TABLE_ROWS = [
        {
            name: "Credits",
            job: "30 Credits/month",
            date: "100 Credits/month",
            Edit: "1100 Credits/month",
        },
        {
            name: "Credits",
            job: "30 Credits/month",
            date: "100 Credits/month",
            Edit: "1100 Credits/month",
        },
        {
            name: "Feature name",
            job: Right(),
            date: Right(),
            Edit: "100 Credits/month",
        },
        {
            name: "Feature name",
            job: Right(),
            date: Right(),
            Edit: "100 Credits/month",
        },
        {
            name: "Feature name",
            job: Right(),
            date: Right(),
            Edit: Right(),
        }, {
            name: "Feature name",
            job: Close(),
            date: Right(),
            Edit: Right(),
        },
        {
            name: "Feature name",
            job: Close(),
            date: Right(),
            Edit: Right(),
        },
        {
            name: "Feature name",
            job: Close(),
            date: Right(),
            Edit: Right(),
        },
        {
            name: "Feature name",
            job: Close(),
            date: Close(),
            Edit: Right(),
        },
        {
            name: "Feature name",
            job: Close(),
            date: Close(),
            Edit: Right(),
        },
    ];

    return (
        <div className='section-padding 1350:pt-[6.25rem] 999:pt-[4rem] pt-[3rem] pb-[3.75rem] '>
            <div className='text-center 1350:mb-[4.375rem] 999:mb-[3.5rem] mb-[3rem] '>
                <h2 className='1650:text-[3.875rem] 1440:text-[3.2rem] 1350:text-[2.9rem] 768:text-[2.4rem] 600:text-[2rem] text-[2.4rem]  font-bold	 primary-text leading-[1.258]	'>Choose Your Plan</h2>
                <p className=' 1650:1350:text-[1.5rem]  1350:text-[1.2rem] 768:text-[1.1rem] 600:text-[1rem] text-[1.2rem] secondary-text font-[450]  leading-[1.20] pt-[.9375rem] pb-[.625rem]'>Lorem ipsum dolor sit amet consectetur. Pulvinar nunc egestas eleifend in vel erat. Massa velit sem aenean ultricies pellentesque est auctor duis placerat. Aliquet sed mi ullamcorper etiam non eu risus purus platea.</p>
                <p className='section-primary-bg text-[1.125rem] pl-[.1875rem] w-fit mx-auto'>7 days free trial.</p>
                <Tabs value="Billed Yearly">

                    <div className='pt-[.9375rem] pb-[3.125rem] flex items-center justify-center gap-[1.25rem]'>
                        <div className='max-w-[20.125rem] '>
                            <TabsHeader className="bg-transparent border border-[#FF904C] text-[1.125rem] font-[450] text-[#72747E] p-0  rounded-[.625rem] " indicatorProps={{
                                className: "rounded-[.5rem] bg-[#FF904C] text-white ",
                            }}>
                                {data.map(({ label, value }) => (
                                    <Tab onClick={() => setActiveValue(value)} className={activeValue == value ? 'text-[#FFF] whitespace-nowrap  rounded-[.625rem] px-[2.25rem]' : 'px-[1.0625rem] text-[#72747E] whitespace-nowrap'} key={value} value={value}>
                                        {label}
                                    </Tab>
                                ))}
                            </TabsHeader>
                        </div>
                        <p className='section-primary-bg text-[1.125rem] pl-[.1875rem] w-fit '>2 months off</p>

                    </div>
                    <TabsBody className='p-0'>
                        {data.map(({ value, desc }) => (
                            <TabPanel className='p-0' key={value} value={value}>
                                {desc}
                            </TabPanel>
                        ))}
                    </TabsBody>
                </Tabs>

            </div>


            <Accordion open={open === 1} >
                <AccordionHeader className='w-full p-0 border-0' onClick={() => handleOpen(1)}>
                    <div className='w-full section-primary-bg 1350:text-[1.5rem] text-[1.2rem] 1350:py-[1.25rem] 999:py-[1.1rem] py-[1rem]  text-center rounded-[.9375rem]  font-[450]'>
                        <div className='flex items-center justify-center gap-[.625rem]'>
                            <div>
                                Hide plan comparision
                            </div>

                            <div >
                                <svg className={`${1 === open ? "rotate-180" : ""}  transition-transform`} xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                    <path d="M6 9.5L12 15.5L18 9.5" stroke="#999CA4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </AccordionHeader>
                <AccordionBody className='py-0'>
                    <div className='py-[1.875rem]'>
                        <div className='flex items-center justify-between'>
                            <Card className="h-full w-full overflow-scroll shadow-none">
                                <table className="w-full min-w-max table-auto text-left">
                                    <thead className=''>
                                        <tr className=''>
                                            {TABLE_HEAD.map((head) => (
                                                <th
                                                    key={head}
                                                    className="1350:text-[1.5rem] text-[1.2rem] font-medium primary-text bg-[#FDFBF7] 1350:p-[1.25rem] 999:p-[1.1rem] p-[1rem] "
                                                >
                                                    <p
                                                        className="font-normal primary-text leading-none "
                                                    >
                                                        {head}
                                                    </p>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody className='mt-3'>
                                        {TABLE_ROWS.map(({ name, job, date, Edit }, index) => {
                                            const isLast = index === TABLE_ROWS.length - 1;
                                            const classes = isLast ? "p-5" : "p-5 border-b border-[#E6E6E6]";

                                            return (
                                                <tr key={name}>
                                                    <td className={classes}>
                                                        <Typography
                                                            className="1350:text-[1.5rem] text-[1.2rem] font-medium primary-text"
                                                        >
                                                            {name}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <p
                                                            className="1350:text-[1.375rem] text-[1.1rem] !font-light  primary-text"
                                                        >
                                                            {job}
                                                        </p>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            className="1350:text-[1.375rem] text-[1.1rem] !font-light  primary-text"
                                                        >
                                                            {date}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                           className="1350:text-[1.375rem] text-[1.1rem] !font-light  primary-text"
                                                        >
                                                            {Edit}
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </Card>
                        </div>
                    </div>
                </AccordionBody>
            </Accordion>
        </div>
    )
}




